<script setup lang="ts">
import type { NuxtError } from '#app'

defineProps({
  error: Object as () => NuxtError,
})

const siteConfig = useSiteConfig()
</script>

<template>
  <div class="text-center min-h-svh">
    <div class="py-2.5 flex justify-center lg:py-5">
      <Anchor to="/" class="flex-none block relative z-2">
        <SiteSwitchComponent name="logo" />
        <span class="sr-only">{{ siteConfig.name }}</span>
      </Anchor>
    </div>
    <p class="typo-sans-1 mt-2.5 block uppercase lg:mt-7">
      {{ error?.statusText }}
    </p>
    <h1 class="typo-serif-4 pt-6 text-center block lg:pt-10">
      {{ error?.status }}
      <br>
      {{ error?.statusText }}
    </h1>
    <div class="mt-6 text-center lg:mt-10">
      <ButtonLink to="/" :title="$t('Continue to homepage')" />
    </div>
  </div>
</template>
